import siteConfig from "../config/siteConfig";

const finiteNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export function calculateStandardShipping({
  itemCount,
  subtotal,
  shipping = siteConfig.shipping,
}) {
  const count = Math.max(0, Math.floor(finiteNumber(itemCount)));
  const orderSubtotal = Math.max(0, finiteNumber(subtotal));
  if (count === 0 || orderSubtotal === 0) return 0;

  const freeThreshold = Number(shipping.freeThreshold);
  if (
    Number.isFinite(freeThreshold) &&
    freeThreshold > 0 &&
    orderSubtotal >= freeThreshold
  ) {
    return 0;
  }

  const baseRate = Math.max(
    0,
    finiteNumber(shipping.standard?.price ?? shipping.flatRate)
  );
  const additionalRate = Math.max(0, finiteNumber(shipping.perAdditionalItem));
  const uncappedRate = baseRate + Math.max(0, count - 1) * additionalRate;
  const maximumCharge = Number(shipping.maximumCharge);

  return Number.isFinite(maximumCharge) && maximumCharge >= 0
    ? Math.min(uncappedRate, maximumCharge)
    : uncappedRate;
}

export function shippingSummary(shipping = siteConfig.shipping) {
  const base = finiteNumber(shipping.standard?.price ?? shipping.flatRate);
  const additional = finiteNumber(shipping.perAdditionalItem);
  const maximum = Number(shipping.maximumCharge);

  if (additional > 0 && Number.isFinite(maximum)) {
    return `$${base.toFixed(2)} for the first item, plus $${additional.toFixed(
      2
    )} per additional item, capped at $${maximum.toFixed(2)}.`;
  }

  return `$${base.toFixed(2)} standard shipping.`;
}
